import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';
import { sendContactMessage } from '../lib/dataService';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill in your name, email and message.');
      return;
    }
    setSending(true);
    try {
      await sendContactMessage(form);
      toast.success('Message sent! We will get back to you soon.');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      toast.error('Failed to send message. Please try again.');
    }
    setSending(false);
  };

  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <span className="page-hero-label">Get In Touch</span>
          <h1>Contact Us</h1>
          <p>We'd love to hear from you — players, parents, coaches, sponsors and fans.</p>
        </div>
      </div>

      <div className="container section contact-grid">
        <div className="contact-info">
          <h2 className="section-title">Cayman Islands Basketball Association</h2>
          <div className="contact-item">
            <div className="quick-icon"><MapPin size={22} /></div>
            <div>
              <h4>Address</h4>
              <p>P.O. Box 186, Grand Cayman,<br />KY1-1104, Cayman Islands</p>
            </div>
          </div>
          <div className="contact-item">
            <div className="quick-icon"><Mail size={22} /></div>
            <div>
              <h4>Email</h4>
              <p><a href="mailto:info@caymanbasketball.com">info@caymanbasketball.com</a></p>
            </div>
          </div>
          <div className="contact-item">
            <div className="quick-icon"><Phone size={22} /></div>
            <div>
              <h4>Phone</h4>
              <p><a href="tel:13459165083">1-345-916-5083</a></p>
            </div>
          </div>
          <p className="contact-note">Need an official letter from CIBA? Visit our <Link to="/page/letter-requests">Letter Requests</Link> page.</p>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Send us a message</h3>
          <div className="form-row">
            <Input placeholder="Your name *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <Input type="email" placeholder="Your email *" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <Input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          <Textarea rows={6} placeholder="Your message *" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <Button type="submit" disabled={sending} className="btn-submit">
            <Send size={16} /> {sending ? 'Sending...' : 'Send Message'}
          </Button>
        </form>
      </div>
    </div>
  );
}
